<ng-container *ngIf="!showForm">
  <table mat-table [dataSource]="model.value" class="mat-elevation" data-test="gsm-fahrrad-liste_table">
    <!-- marke Column -->
    <ng-container matColumnDef="marke">
      <th mat-header-cell *matHeaderCellDef>Marke</th>
      <td mat-cell *matCellDef="let element">{{ element.marke || 'Siehe Nachweis' }}</td>
    </ng-container>

    <!-- alter Column -->
    <ng-container matColumnDef="alter">
      <th mat-header-cell *matHeaderCellDef>Alter</th>
      <td mat-cell *matCellDef="let element">{{ element.alter || '' }}</td>
    </ng-container>

    <!-- anschaffungspreis Column -->
    <ng-container matColumnDef="anschaffungspreis">
      <th mat-header-cell *matHeaderCellDef>Anschaffungspreis</th>
      <td mat-cell *matCellDef="let element">
        {{ element.anschaffungspreis && '€ ' }}{{ element.anschaffungspreis | number: '1.2-2':'de-DE' }}
      </td>
    </ng-container>

    <!-- nachweis-dokument Column -->
    <ng-container matColumnDef="nachweisdokument">
      <th mat-header-cell *matHeaderCellDef>Nachweis-Dokument</th>
      <td mat-cell *matCellDef="let element" class="filename">
        {{ getNachweisDokumentLabel(element) }}
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Aktionen</th>
      <td mat-cell *matCellDef="let element; let index = index">
        <button mat-icon-button (click)="editItem(element, index)" data-test="gsm-fahrrad-liste_edit">
          <mat-icon>{{ model.disabled ? 'visibility' : 'edit' }}</mat-icon>
        </button>
        <button mat-icon-button *ngIf="!model.disabled" (click)="removeItem(index)"
                data-test="gsm-fahrrad-liste_delete">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['marke', 'alter', 'anschaffungspreis', 'nachweisdokument', 'actions']"></tr>
    <tr mat-row
        *matRowDef="let row; columns: ['marke', 'alter', 'anschaffungspreis', 'nachweisdokument', 'actions']"></tr>
  </table>
</ng-container>
<div class="add-item" *ngIf="!showForm && !model.disabled" (click)="setForm(null)" data-test="gsm-fahrrad-liste_add">
  <button mat-mini-fab color="primary">
    <mat-icon>add</mat-icon>
  </button>
  <span class="label">Fahrrad hinzufügen</span>
</div>
<form *ngIf="showForm" [formGroup]="entryFormGroup">
  <dynamic-material-form
    [group]="entryFormGroup"
    [model]="entryFormModel"
    (matEvent)="onCustomEvent($event, null, true)"
    data-test="gsm-fahrrad-liste_entry-form"
  ></dynamic-material-form>
  <button mat-raised-button class="cancel-button" (click)="cancelEdit()" data-test="gsm-fahrrad-liste_cancel-btn">
    {{ model.disabled ? 'Schließen' : 'Abbrechen' }}
  </button>
  <button
    mat-raised-button
    color="primary"
    class="gsm-fahrrad-liste_save-btn"
    *ngIf="!model.disabled"
    [disabled]="!isEntryFormValid || isSaving"
    (click)="saveItem($event)"
    data-test="gsm-fahrrad-liste_save-btn"
  >
    <span *ngIf="!isSaving">Speichern</span>
    <mat-spinner [diameter]="30" *ngIf="isSaving"></mat-spinner>
  </button>
</form>
